<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <main>
      <h1 class="vtz-h1 vtz-text--center" i18n>
        Change Password
      </h1>
      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="vtz-form">
        <div class="vtz-form__row">
          <div class="vtz-form__item">
            <label class="vtz-form__label" for="currentPassword" i18n>Old password<span class="vtz--red">*</span></label>
            <div class="pin-special">
              <input class="vtz-form__input" autocomplete="off" [type]="hide0 ? 'password' : 'text'" type="text"
                id="currentPassword" formControlName="currentPassword" name="currentPassword"
                [ngClass]="{ 'vtz-form__input--error': passwordForm.controls['currentPassword'].dirty &&
                passwordForm.controls['currentPassword'].invalid}" />
              <mat-icon class="hide-show" aria-hidden="true" matSuffix (click)="hide0 = !hide0">{{hide0 ? 'visibility_off'
                : 'visibility'}}</mat-icon>
            </div>
            @if(passwordForm.get('currentPassword')?.touched && passwordForm.get('currentPassword')?.hasError('required')) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">
                  Old password required
                </span>
              </div>
            }
          </div>
        </div>
        <div class="vtz-form__row">
          <div class="vtz-form__item">
            <label class="vtz-form__label" for="password1" i18n>New password<span class="vtz--red">*</span></label>
            <div class="pin-special">
              <input class="vtz-form__input" autocomplete="off" [type]="hide1 ? 'password' : 'text'" type="text"
                id="password1" formControlName="password1" name="password1"
                [ngClass]="{ 'vtz-form__input--error': passwordForm.controls['password1'].dirty &&
                passwordForm.controls['password1'].invalid}" />
              <mat-icon class="hide-show" aria-hidden="true" matSuffix (click)="hide1 = !hide1">{{hide1 ? 'visibility_off'
                : 'visibility'}}</mat-icon>
            </div>
            
            @if(passwordForm.get('password1')?.touched && passwordForm.get('password1')?.hasError('required')) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">
                  New password required
                </span>
              </div>
            }
          </div>
        </div>
        <div class="vtz-form__row">
          <div class="vtz-form__item">
            <label class="vtz-form__label" for="password2" i18n>Confirm new password<span class="vtz--red">*</span></label>
            <div class="pin-special">
              <input class="vtz-form__input" autocomplete="off" [type]="hide2 ? 'password' : 'text'" type="text"
                id="password2" formControlName="password2" name="password2"
                [ngClass]="{ 'vtz-form__input--error': passwordForm.controls['password2'].dirty &&
                passwordForm.controls['password2'].invalid}" />
              <mat-icon class="hide-show" aria-hidden="true" matSuffix (click)="hide2 = !hide2">{{hide2 ? 'visibility_off'
                : 'visibility'}}</mat-icon>
            </div>
            @if(!passwordForm.get('password2')?.touched && passwordForm.errors?.['PasswordNoMatch']) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">
                  The passwords do not match.
                </span>
              </div>
            }
            @if(passwordForm.get('password2')?.touched && passwordForm.errors?.['PasswordNoMatch']) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">
                  The passwords do not match. You can check the passwords by clicking on the eye icon.
                </span>
              </div>
            }
          </div>
        </div>
        <div class="validation-hints">
          <h5 i18n>Password Rules:</h5>
          <div class="validation-item" [ngClass]="{
              'text-danger': !passwordRequirements.hasUpperCase,
              'text-success': passwordRequirements.hasUpperCase
            }" i18n>
            <span>{{ passwordRequirements.hasUpperCase ? '✓' : '✗' }}</span>
            Must have at least 1 upper case letter.
          </div>
          <div class="validation-item" [ngClass]="{
            'text-danger': !passwordRequirements.hasLowerCase,
            'text-success': passwordRequirements.hasLowerCase
            }" i18n>
            <span>{{ passwordRequirements.hasLowerCase ? '✓' : '✗' }}</span>
            Must have at least 1 lower case letter.
          </div>
          <div class="validation-item" [ngClass]="{
            'text-danger': !passwordRequirements.hasNumber,
            'text-success': passwordRequirements.hasNumber
            }" i18n>
            <span>{{ passwordRequirements.hasNumber ? '✓' : '✗' }}</span>
            Must have at least 1 number.
          </div>
          <div class="validation-item" [ngClass]="{
            'text-danger': !passwordRequirements.hasSpecialChar,
            'text-success': passwordRequirements.hasSpecialChar
            }" i18n>
            <span>{{ passwordRequirements.hasSpecialChar ? '✓' : '✗' }}</span>
            Must have at least 1 special character.
          </div>
          <div class="validation-item" [ngClass]="{
            'text-danger': !passwordRequirements.isValidLength,
            'text-success': passwordRequirements.isValidLength
            }" i18n>
            <span>{{ passwordRequirements.isValidLength ? '✓' : '✗' }}</span>
            Must have at least 12 characters.
          </div>
        </div>

        <div class="vtz-actions">
          <div class="button-group">
            <button i18n class="button-primary" style="max-width: 120px;" (click)="cancel()">Cancel</button>
            <button i18n class="button-primary" style="max-width: 120px;" type="submit"
              [disabled]="passwordForm.invalid">Save</button>
          </div>  
        </div>
      </form>
      @if (displaySpinner) {
        <div class="progressSpinner">
          <mat-spinner [diameter]="300" color="primary"></mat-spinner>
          <div class="spinner-warning">
            <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
          </div>
        </div>
      }
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>
